import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { getNotificationMessage } from '@notifications/registry';
import { INotificationMessage } from './interfaces';

export const NotificationMessage: React.FC<INotificationMessage> = ({
  notification,
}): JSX.Element => {
  const { t } = useTranslation();
  const message = getNotificationMessage(notification);

  if (!message) {
    return <Fragment>{t('notifications:unknown')}</Fragment>;
  }

  return message;
};
